import useTypedFlags from "hooks/useTypedFlags";

import ModulePullRequestsList from "./List";
import ModulePullRequestsListLegacy from "./ListLegacy";

const ModulePullRequests = () => {
  const { stackPullRequestsListRedesign } = useTypedFlags();

  if (!stackPullRequestsListRedesign) {
    return <ModulePullRequestsListLegacy />;
  }

  return <ModulePullRequestsList />;
};

export default ModulePullRequests;
